import { createSelector } from '@reduxjs/toolkit'
import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'

const pluckAutonomousRegionId = (_, { id }) => id

const getAutonomousRegions = (state) => state.autonomousRegions.items || []

/**
 * @deprecated use RTKQ hooks
 */
export const getAutonomousRegionsOrderedByName = createSelector([getAutonomousRegions], (autonomousRegions) =>
    _sortBy(autonomousRegions, ['name'])
)

/**
 * @deprecated use RTKQ hooks
 */
export const getAutonomousRegionNameById = createSelector(
    [getAutonomousRegions, pluckAutonomousRegionId],
    (autonomousRegions, id) => _find(autonomousRegions, { id })?.name
)
